export default __webpack_public_path__ + "static/media/Uu.1a03835a.wav";